import * as Yup from "yup"; // Import Yup

// {
//     value : email | phoneNumber
// }

const forgotPasswordValidationSchema = Yup.object().shape({
    value: Yup.string().required("Email or Phone Number is required"),
});

export default forgotPasswordValidationSchema;
